import navigate from '@/utils/navigate';
import percentage from '@/utils/percentage';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { active, disabled, total, wise_boxes } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Devices
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
                <br/>
                <Typography variant="body2">
                    Active: {active} ({percentage(active, total)})
                    <br/>
                    Disabled: {disabled} ({percentage(disabled, total)})
                </Typography>
                <br/>
                <Typography color="text.secondary" sx={{ mb: 0.5 }}>
                    WiseBoxes: {wise_boxes}
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
                <Button onClick={() => navigate('/devices')}>View Devices</Button>
            </CardActions>
        </Card>
    );
};

export default Component;
